import PersonaInterview from './PersonaInterview';

export default PersonaInterview;
